<template>
    <div class="w-full flex justify-center text-center pb-2xl mx-auto">
        <h1
            class="pt-6 pb-3 px-4"
            :class="[getConfig.isCursive.value ? 'font-decorative font-light text-5xl md:text-6xl xl:text-8xl' : 'text-6xl font-bold md:text-7xl xl:text-9xl']"
        >
            {{ headline }}
        </h1>
    </div>
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'
import {computed, ref} from "vue";

const props = defineProps<{
    content: HblSlot,
}>()

const getConfig = computed(() => {
    return props?.content?.config
})

const getData = computed(() => {
    return props?.content?.data
})

const headline = ref(getData.value?.headline ? getData.value?.headline : getConfig.value?.headline.value)
</script>